import { Text, Button } from 'v3/components';
import AddAddress from '../AddAdress';
import * as Styled from './styles';

export default function TravelEditCard({
	enableEdit = false,
	externalLoading = false,
	disableStartEdit = false,
	onStartEdit = () => {},
	onSaveChanges = () => {},
	onCancelEdit = () => {},
	showActions = false,
	showCreateForm = false,
	showEditForm = false,
	showForm = false,
	formMode = 'add',
	pointData = null,
	onPointChange = null,
	onPointSave = null,
	canEditRoute = true,
	createPoint = {},
	setCreatePoint = () => {},
	editingPoint = {},
	setEditingPoint = () => {},
	onSaveCreate = () => {},
	onSaveEdit = () => {},
	countryOptions = [],
	isFirstPoint = false,
	origins = [],
	destinations = [],
	pointsListRef = null,
	formRef = null,
	validateRetroactive = true,
}) {
	const effectiveShowCreateForm = showCreateForm || (showForm && formMode === 'add');
	const effectiveShowEditForm = showEditForm || (showForm && formMode === 'edit');
	const shouldShowForm = (effectiveShowCreateForm || effectiveShowEditForm) && canEditRoute;
	const effectiveMode = effectiveShowEditForm ? 'edit' : 'add';
	const effectivePointData =
		formMode === 'edit' || effectiveMode === 'edit'
			? (pointData ?? editingPoint)
			: (pointData ?? createPoint);
	const effectiveOnChange =
		formMode === 'edit' || effectiveMode === 'edit'
			? (onPointChange ?? setEditingPoint)
			: (onPointChange ?? setCreatePoint);
	const effectiveOnSave =
		formMode === 'edit' || effectiveMode === 'edit'
			? (onPointSave ?? onSaveEdit)
			: (onPointSave ?? onSaveCreate);
	const formTitle =
		effectiveMode === 'edit' ? 'Editar ponto existente' : 'Criar novo ponto';

	return (
		<>
			{showActions && (
				<Styled.Actions>
					{!enableEdit && (
						<Button
							variant="secondary"
							onClick={onStartEdit}
							loading={externalLoading}
							disabled={externalLoading || disableStartEdit}
						>
							Editar
						</Button>
					)}

					{enableEdit && (
						<>
							<Button
								variant="secondary"
								onClick={onCancelEdit}
								loading={externalLoading}
								disabled={externalLoading}
							>
								Cancelar
							</Button>
							<Button
								variant="primary"
								onClick={onSaveChanges}
								loading={externalLoading}
								disabled={externalLoading}
							>
								Salvar
							</Button>
						</>
					)}
				</Styled.Actions>
			)}

			{shouldShowForm && (
				<Styled.FormBlock ref={formRef}>
					<Text type="header" style={{ marginBottom: '0.75rem' }}>
						{formTitle}
					</Text>
					<AddAddress
						data={effectivePointData}
						onChange={effectiveOnChange}
						onSave={effectiveOnSave}
						countryOptions={countryOptions}
						showTypeSelect={!isFirstPoint}
						action={effectiveMode}
						isFirst={isFirstPoint}
						origins={origins}
						destinations={destinations}
						pointsListRef={pointsListRef}
						validateRetroactive={validateRetroactive}
					/>
				</Styled.FormBlock>
			)}
		</>
	);
}
